import { initSDK as initAuthSDK } from '@lusha/auth-client-sdk';
import { initSDK as initBannersSDK } from '@lusha/banners-manager';
import { initSDK as initBIClientSDK } from '@lusha/bi-client-sdk';
import { logger } from '@lusha/client-logger';
import ContactSalesCTA from '@lusha/contact-sales-cta';
import { initSDK as initCreditsWidgetSDK } from '@lusha/credits-widget';
import { EXPERIMENT_PROJECTS, initSDK as initExperimentSDK } from '@lusha/experiment-react-sdk';
import { initSDK as initBrazeSDK } from '@lusha/lusha-braze';
import { initSDK as initQuerySDK } from '@lusha/react-query';
import { PLATFORM } from '@lusha/source-platforms';
import { getEnv } from '@lusha-app/env';
import { initSDK as initGrowthBIClientSDK } from '@lusha-growth/bi-client-sdk';
import { initSDK as initIntegrationsWidgetsSdk } from 'lusha-integrations-widgets';
import { FLAG_SETTINGS } from './experiments/flags';
import eventsSchemaVersions from './utils/BIEvents/eventsSchemaVersions';
import { APP_ID } from './utils/constants';
const env = getEnv();
logger.init({
    env,
    scope: 'lusha-plugin-app',
    logLevel: envConfig.LOG_LEVEL || 'warn',
    token: envConfig.CLIENT_TOKEN,
    handler: process.env.NODE_ENV,
    supportMfe: false, // true causing recursive error spam from inside coralogix
    version: envConfig.VERSION_COMMIT_ID,
    blockedKeywords: envConfig.BLOCKED_KEY_WORDS,
});
initQuerySDK({
    baseUrl: envConfig.OUTBOUND_SERVER_URL,
});
initBannersSDK({
    env: envConfig.ENV,
});
initBIClientSDK({
    env,
    defaultCategory: 'plugin',
    defaultTeamName: 'plugin',
    defaultMetadata: {
        platform: PLATFORM.PLUGIN,
    },
    nameSchemaIdMap: eventsSchemaVersions,
    enabled: true,
});
initGrowthBIClientSDK({
    env,
    defaultCategory: 'plugin',
    defaultTeamName: 'plugin',
    defaultMetadata: {
        platform: PLATFORM.PLUGIN,
    },
    nameSchemaIdMap: eventsSchemaVersions,
    enabled: true,
});
initExperimentSDK({
    env,
    loggedUsersOnly: true,
    flagSettings: FLAG_SETTINGS,
    defaultProject: EXPERIMENT_PROJECTS.PLUGIN,
    appId: APP_ID,
});
initBrazeSDK({
    env,
});
initAuthSDK({
    env,
});
initIntegrationsWidgetsSdk({
    env,
    features: {
        HIDE_JOB_TITLES: true,
    },
    variant: 'plugin',
});
ContactSalesCTA.init({ env });
initCreditsWidgetSDK({ env, baseURL: envConfig.OUTBOUND_SERVER_URL });
